export const PHONE_DISPLAY = "06 48 24 77 54";
export const PHONE_TEL = "tel:+31648247754";
export const WA_NUMBER = "31648247754";
export const WA_LINK = `https://wa.me/${WA_NUMBER}`;

export const waLink = (text) =>
    text ? `${WA_LINK}?text=${encodeURIComponent(text)}` : WA_LINK;

export const IMAGES = {
    passat: "/images/passat-eigen.jpg",
    lynk: "/images/lynk-co-01.jpg",
    interior: "https://images.unsplash.com/photo-1491515554378-d827a5ffcf43?q=80&w=1600&auto=format&fit=crop",
};

export const NAV_ITEMS = [
    { path: "/", key: "home" },
    { path: "/diensten", key: "diensten" },
    { path: "/werkgebied", key: "werkgebied" },
    { path: "/onze-taxi", key: "onzeTaxi" },
    { path: "/over-ons", key: "overOns" },
    { path: "/boeken", key: "boeken" },
    { path: "/contact", key: "contact" },
];

export const RIT_KEYS = ["regular", "airport", "business", "daily", "event", "long", "group"];
